import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { FetchPriority, type Studio } from '../../base/package/api/package/gaming/gaming-domain';
import '../ui-provider-tile/ui-provider-tile';
import './ui-custom-carousel';
import componentStyle from './ui-studios-carousel.css?inline';

const CName = 'ui-studios-carousel';

/**
 * @param {string} padding - This padding will be applied to the start and end of the carousel.
 */
@customElement(CName)
export class UIStudiosCarousel extends LitElement {
  static readonly styles = unsafeCSS(componentStyle);

  @property({ type: String }) fetchPriority: FetchPriority = FetchPriority.AUTO;
  @property({ type: String }) source?: string;
  @property({ type: Array }) studios: Studio[];
  @property({ type: String }) padding = '0';

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'list');
  }

  render() {
    return html`<ui-custom-carousel .padding=${this.padding}>${this._renderStudiosUi(this.studios)}</ui-custom-carousel>`;
  }

  private _renderStudiosUi(studios: Studio[]) {
    if (studios.length < 1) {
      // Render placeholder tile
      return html`<ui-provider-tile></ui-provider-tile>`;
    }
    return studios.map((tile) => {
      return html`
        <div class="carousel-item" role="listitem">
          <ui-provider-tile
            .amount=${tile.gamesTotalCount}
            .id=${tile.id}
            .image=${tile.img ?? ''}
            .slug=${tile.slug}
          ></ui-provider-tile>
        </div>
      `;
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIStudiosCarousel;
  }
}
